import React, { FC, ChangeEvent } from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';
import { YearsOfExperienceSectionProps } from './types';

const YearsOfExperienceSection: FC<YearsOfExperienceSectionProps> = ({ value, onChange }) => {
  const handleInputChange = (key: 'min' | 'max') => (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    const next = { ...(value || {}) };
    if (input === '') {
      delete next[key];
      onChange(next);
      return;
    }

    const parsed = parseInt(input, 10);
    if (Number.isNaN(parsed)) {
      return;
    }
    next[key] = parsed;
    onChange(next);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Stack direction="column" spacing={1} sx={{ width: '50%' }}>
          <Typography variant="h6" sx={{ mb: 1, fontSize: '14px' }}>
            Min. years of experience
          </Typography>
          <TextField
            type="number"
            placeholder="e.g. 1"
            value={value?.min ?? ''}
            onChange={handleInputChange('min')}
            size="small"
            sx={{ '& .MuiInputBase-input': { fontSize: 14 } }}
          />
        </Stack>
        <Stack direction="column" spacing={1} sx={{ width: '50%' }}>
          <Typography variant="h6" sx={{ mb: 1, fontSize: '14px' }}>
            Max. years of experience
          </Typography>
          <TextField
            type="number"
            placeholder="e.g. 5"
            value={value?.max ?? ''}
            onChange={handleInputChange('max')}
            size="small"
            sx={{ '& .MuiInputBase-input': { fontSize: 14 } }}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default YearsOfExperienceSection;
